import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ThankYou from "../pages/thank-you/page";
import JointMobilityReport from "../pages/joint-mobility-report/page";
import JointMobilityReportPDF from "../pages/joint-mobility-report/pdf/page";
import TermsOfUse from "../pages/terms/page";
import PrivacyPolicy from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/obrigado",
    element: <ThankYou />,
  },
  {
    path: "/the-joint-mobility-report",
    element: <JointMobilityReport />,
  },
  {
    path: "/the-joint-mobility-report/pdf",
    element: <JointMobilityReportPDF />,
  },
  {
    path: "/terms",
    element: <TermsOfUse />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;